import React, { FC } from 'react'
import Auth from './Auth'
import Account from './Account'
import styles from './Account.module.scss'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import { isAuthenticated } from 'selectors/user/session'

const Authentication: FC = () => {
  const authenticated = useSelector(isAuthenticated)

  return (
    <div
      className={classNames(styles.accountContainer, {
        [styles.accountContainerAuthenticated]: authenticated,
      })}
      data-type='account-container'
    >
      {authenticated ? <Account /> : <Auth />}
    </div>
  )
}
export default Authentication
